'use client';

// 상담 신청 완료 전환 신호 (네이버 광고 + 구글·유튜브 광고). 신청이 실제로 저장된 뒤 한 번 부른다
import { trackNaverLeadConversion } from '@/lib/naver';
import { trackEvent } from '@/lib/track-client';

// 구글 광고 전환: 환경 변수에 전환 ID(AW-…)와 전환 라벨을 넣으면 켜진다 (없으면 아무것도 하지 않음)
export const GOOGLE_ADS_ID = process.env.NEXT_PUBLIC_GOOGLE_ADS_ID ?? '';
export const GOOGLE_ADS_LEAD_LABEL = process.env.NEXT_PUBLIC_GOOGLE_ADS_LEAD_LABEL ?? '';

export function trackLeadConversion() {
  trackNaverLeadConversion();
  trackEvent('form_submit');
  try {
    const w = window as unknown as { gtag?: (...args: unknown[]) => void };
    if (GOOGLE_ADS_ID && GOOGLE_ADS_LEAD_LABEL && typeof w.gtag === 'function') {
      w.gtag('event', 'conversion', { send_to: `${GOOGLE_ADS_ID}/${GOOGLE_ADS_LEAD_LABEL}` });
    }
  } catch {
    // ignore
  }
}
